export default __webpack_public_path__ + "static/media/atarud.ca47ca96.png";